/**
 * @generated SignedSource<<b050afaabfab9a5a179ad5fab80ea762>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type StoredObjectType = "ALL" | "CURRICULUM_ALIGNMENT_DOCUMENTS" | "PRACTICE_PROBLEMS" | "WORKED_EXAMPLE_VIDEO" | "%future added value";
export type PresignedUrlsForSkillFilterInput = {
  storedObjectType: StoredObjectType;
};
export type SkillsGuidedTourContentQuery$variables = {
  ancestriesIds?: ReadonlyArray<string> | null | undefined;
  skillCode: string;
  urlsFilter: PresignedUrlsForSkillFilterInput;
};
export type SkillsGuidedTourContentQuery$data = {
  readonly presignedURLsForSkill: {
    readonly workedExampleVideoEnglishCaptionUrl: string | null | undefined;
    readonly workedExampleVideoSpanishCaptionUrl: string | null | undefined;
    readonly workedExampleVideoUrl: string | null | undefined;
  };
  readonly searchSkills: {
    readonly nodes: ReadonlyArray<{
      readonly code: string | null | undefined;
      readonly skillAncestries: ReadonlyArray<{
        readonly ancestorSkill: {
          readonly code: string | null | undefined;
          readonly id: string;
          readonly name: string | null | undefined;
        } | null | undefined;
        readonly skillRelevance: {
          readonly id: string;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    }> | null | undefined;
  } | null | undefined;
  readonly siteSpecificSkillInfoBySkillCode: {
    readonly assessmentInfo: string | null | undefined;
    readonly code: string | null | undefined;
    readonly context: string | null | undefined;
    readonly essentialQuestion: string | null | undefined;
    readonly id: string;
    readonly name: string | null | undefined;
    readonly skillStories: ReadonlyArray<{
      readonly description: string | null | undefined;
      readonly id: string;
      readonly profession: string | null | undefined;
      readonly story: string | null | undefined;
    } | null | undefined> | null | undefined;
    readonly standards: ReadonlyArray<{
      readonly description: string | null | undefined;
      readonly id: string;
      readonly longName: string | null | undefined;
    } | null | undefined> | null | undefined;
    readonly summary: string | null | undefined;
    readonly vocabularies: ReadonlyArray<{
      readonly definition: string | null | undefined;
      readonly id: string;
      readonly term: string | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type SkillsGuidedTourContentQuery = {
  response: SkillsGuidedTourContentQuery$data;
  variables: SkillsGuidedTourContentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ancestriesIds"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skillCode"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "urlsFilter"
},
v3 = {
  "kind": "Variable",
  "name": "skillCode",
  "variableName": "skillCode"
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": [
    (v3/*: any*/)
  ],
  "concreteType": "SkillNode",
  "kind": "LinkedField",
  "name": "siteSpecificSkillInfoBySkillCode",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v5/*: any*/),
    (v6/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "summary",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "assessmentInfo",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "essentialQuestion",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "context",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "VocabularyNode",
      "kind": "LinkedField",
      "name": "vocabularies",
      "plural": true,
      "selections": [
        (v5/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "term",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "definition",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SkillStoryNode",
      "kind": "LinkedField",
      "name": "skillStories",
      "plural": true,
      "selections": [
        (v5/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "profession",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "story",
          "storageKey": null
        },
        (v7/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "StandardNode",
      "kind": "LinkedField",
      "name": "standards",
      "plural": true,
      "selections": [
        (v5/*: any*/),
        (v7/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "longName",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "filter",
      "variableName": "urlsFilter"
    },
    (v3/*: any*/)
  ],
  "concreteType": "SkillPresignedUrls",
  "kind": "LinkedField",
  "name": "presignedURLsForSkill",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "workedExampleVideoUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "workedExampleVideoEnglishCaptionUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "workedExampleVideoSpanishCaptionUrl",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v10 = [
  {
    "kind": "Variable",
    "name": "searchQuery",
    "variableName": "skillCode"
  }
],
v11 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "skillRelevanceIds",
        "variableName": "ancestriesIds"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  }
],
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "SkillRelevanceNode",
  "kind": "LinkedField",
  "name": "skillRelevance",
  "plural": false,
  "selections": [
    (v5/*: any*/)
  ],
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "SkillNode",
  "kind": "LinkedField",
  "name": "ancestorSkill",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    (v4/*: any*/),
    (v6/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "SkillsGuidedTourContentQuery",
    "selections": [
      (v8/*: any*/),
      (v9/*: any*/),
      {
        "alias": null,
        "args": (v10/*: any*/),
        "concreteType": "SkillNodeConnection",
        "kind": "LinkedField",
        "name": "searchSkills",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SkillNode",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v6/*: any*/),
              {
                "alias": null,
                "args": (v11/*: any*/),
                "concreteType": "SkillAncestryNode",
                "kind": "LinkedField",
                "name": "skillAncestries",
                "plural": true,
                "selections": [
                  (v12/*: any*/),
                  (v13/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "SkillsGuidedTourContentQuery",
    "selections": [
      (v8/*: any*/),
      (v9/*: any*/),
      {
        "alias": null,
        "args": (v10/*: any*/),
        "concreteType": "SkillNodeConnection",
        "kind": "LinkedField",
        "name": "searchSkills",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SkillNode",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v6/*: any*/),
              {
                "alias": null,
                "args": (v11/*: any*/),
                "concreteType": "SkillAncestryNode",
                "kind": "LinkedField",
                "name": "skillAncestries",
                "plural": true,
                "selections": [
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ac74a17247b118451588e456fb00eca0",
    "id": null,
    "metadata": {},
    "name": "SkillsGuidedTourContentQuery",
    "operationKind": "query",
    "text": "query SkillsGuidedTourContentQuery(\n  $skillCode: String!\n  $urlsFilter: PresignedUrlsForSkillFilterInput!\n  $ancestriesIds: [ID!]\n) {\n  siteSpecificSkillInfoBySkillCode(skillCode: $skillCode) {\n    name\n    id\n    code\n    summary\n    assessmentInfo\n    essentialQuestion\n    context\n    vocabularies {\n      id\n      term\n      definition\n    }\n    skillStories {\n      id\n      profession\n      story\n      description\n    }\n    standards {\n      id\n      description\n      longName\n    }\n  }\n  presignedURLsForSkill(skillCode: $skillCode, filter: $urlsFilter) {\n    workedExampleVideoUrl\n    workedExampleVideoEnglishCaptionUrl\n    workedExampleVideoSpanishCaptionUrl\n  }\n  searchSkills(searchQuery: $skillCode) {\n    nodes {\n      code\n      skillAncestries(filter: {skillRelevanceIds: $ancestriesIds}) {\n        skillRelevance {\n          id\n        }\n        ancestorSkill {\n          id\n          name\n          code\n        }\n        id\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3c18fd9e15dbf76f88c0f75d10cb7351";

export default node;
